<template>
  <div>
    <ul>
      <li>
        <InputText v-model="startTemp" :class="{ 'p-invalid': startTempEmpty }"/>
      </li>
      <li>
        <InputText v-model="endTemp" :class="{ 'p-invalid': endTempEmpty }"/>
      </li>
      <li>
        <div class="imput-unity">
          <InputText v-model="density" :class="{ 'p-invalid': densityEmpty }"/>
        </div>
      </li>
      <li style="width: 75px;">
        <div style="margin: auto;">{{ unity }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LineTable',
  props: {
    unity: String
  },
  data() {
    return {
      startTempEmpty: false,
      startTemp: '',
      endTemp: '',
      endTempEmpty: false,
      density: '',
      densityEmpty: false,
      control: true,
    }
  },
  methods: {
    control_empty() {
      this.control = true
      if (this.startTemp === '') {
        this.startTempEmpty = true
        this.control = false
      }
      if (this.endTemp === '') {
        this.endTempEmpty = true
        this.control = false
      }
      if (this.density === '') {
        this.densityEmpty = true
        this.control = false
      }
      return this.control
    },
    clearAll() {
      this.startTemp = ''
      this.endTemp = ''
      this.density = ''
    },
    sendLine() {
      if (this.startTemp && this.endTemp && this.density) {
        return {
          'start': this.startTemp,
          'end': this.endTemp,
          'density': this.density
        }
      } else {
        return false
      }
    }
  },
  watch: {
    startTemp() {
      if (this.startTemp !== '') {
        this.startTempEmpty = false
      }
      let control = this.sendLine()
      if (control) {
        this.$emit('data', control)
      }
    },
    endTemp() {
      if (this.endTemp !== '') {
        this.endTempEmpty = false
      }
      let control = this.sendLine()
      if (control) {
        this.$emit('data', control)
      }
    },
    density() {
      if (this.density !== '') {
        this.densityEmpty = false
      }
      let control = this.sendLine()
      if (control) {
        this.$emit('data', control)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.p-inputtext {
  font-size: 90% !important;
}

.imput-unity {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
}
</style>
